import Axios from 'axios';
import { RolesPayload, LocationPayload, LocationSystemModePayload, PESPayload, GetLocationsParameters, GetLocationsResponse, GetLocationsFacetsParameters, GetLocationsFacetResponse } from 'model/api';
import { toPairs, pickBy } from 'lodash';

export const editLocationRoles = async (locationId: string, userId: string, payload: RolesPayload): Promise<any> => {
  const response = await Axios.put(`/locations/${locationId}/user-roles/${userId}`, payload);
  return response.data;
}

export const removeLocationRoles = async (locationId: string, userId: string): Promise<any> => {
  const response = await Axios.delete(`/locations/${locationId}/user-roles/${userId}`);
  return response.data;
}

export const getLocationById = async (locationId: string, expand: string[] = []): Promise<any> => {
  const parameters = (expand.length > 0) ? `?expand=${expand.join(',')}` : '';
  const response = await Axios.get(`/locations/${locationId}${parameters}`);
  return response.data;
}

export const createLocation = async (location: LocationPayload): Promise<any> => {
  const response = await Axios.post('/locations', location);
  return response.data;
}

export const editLocation = async (locationId: string, location: LocationPayload): Promise<any> => {
  const response = await Axios.post(`/locations/${locationId}`, location);
  return response.data;
}

export const removeLocation = async (locationId: string): Promise<any> => {
  const response = await Axios.delete(`/locations/${locationId}`);
  return response.data;
}

export const setLocationSystemMode = async (locationId: string, systemModePayload: LocationSystemModePayload): Promise<any> => {
  const response = await Axios.post(`/locations/${locationId}/systemMode`, systemModePayload);
  return response.data;
}

export const setLocationFloSense = async (locationId: string, thresholdsPayload: PESPayload): Promise<any> => {
  const response = await Axios.post(`/locations/${locationId}/floSense`, thresholdsPayload);
  return response.data;
}

export const getLocations = async (parameters: GetLocationsParameters): Promise<GetLocationsResponse> => {
  const removeUndefined = pickBy(parameters, v => v !== undefined);
  const params = toPairs(removeUndefined).map(([param, value]: [string, string|number|undefined]) => `${param}=${encodeURIComponent(value as any)}`);
  const query = (params.length > 0) ? `?${params.join("&")}` : '';
  const response = await Axios.get(`/locations${query}`);
  return response.data;
}

export const getFacets = async (parameters: GetLocationsFacetsParameters): Promise<GetLocationsFacetResponse> => {
  const removeUndefined = pickBy(parameters, v => v !== undefined);
  const params = toPairs(removeUndefined).map(([param, value]: [string, string|number|undefined|string[]]) => {
    const val = Array.isArray(value) ? value.join(',') : value;
    return `${param}=${encodeURIComponent(val as any)}`;
  });
  const query = (params.length > 0) ? `?${params.join("&")}` : '';
  const response = await Axios.get(`/locations/facets${query}`);
  return response.data;
}
